export default __webpack_public_path__ + "static/media/avatar-2.d6a64ff8.png";